import React, { useContext, useEffect, useState } from "react";
import { PageStep } from "./StepPage.types";
import { AppContext } from "../../../util/context";
import { sanitizeContent as s, replaceVariablesInText, getFieldsFormSession } from "../../../util/functions";
import NextButton from "../Buttons/NextButton";
import VideoElement from "../../VideoElement";
import SkipButton from "../Buttons/SkipButton";
import styles from "./StepPage.module.scss";
import block from 'bem-css-modules';

const StepPage = (props: { stepData: PageStep, activeStepIndex: number, stepIndex: number }) => {
  const context = useContext(AppContext);
  const { handleStepSubmit, settings: { submitButtonText, crm } } = context;
  const { product } = crm[0];

  const [doctorData, setDoctorData] = useState<any>(false);
  const [processedContent, setProcessedContent] = useState<string>("");

  const {
    activeStepIndex,
    stepIndex,
    stepData: {
      content,
      iframe,
      vimeoId,
      isSuccessPage,
      skipButton,
      doctorContactPage,
      doctorContactField,
      stepSettings: [{
        uuid,
        label,
        customNextButton,
        classes,
        nextStep,
        lastStep,
      }],
    },
  } = props;

  const b = block(styles);

  // TEMP(DTX-300): opt-in "copy to clipboard" button for the Mictera prefilled
  // e-mail. Clipboard needs JS, which can't live in sanitized Dato content, so
  // it's a component button gated on the step's `classes` marker `fc-copy-mail`
  // (copies the rx_mail_body session value). No-op for any other form/step.
  const [copied, setCopied] = useState(false);
  const showCopyMail = (classes || "").split(" ").includes("fc-copy-mail");
  const handleCopyMail = () => {
    const text = getFieldsFormSession("rx_mail_body");
    if (!text) return;
    navigator.clipboard?.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => undefined);
  };

  const handleClick = () => {
    const stepData = {
      label: label,
      uuid: uuid,
      settings: {
        tracking: {
          gtmEvent: `formClient.step.${label}`
        },
        classes,
        custom_next_button: customNextButton,
        next_step: nextStep,
        last_step: lastStep
      },
    }

    handleStepSubmit(context, stepData);
  }

  useEffect(()=> { 
    if (!content) return;
    setProcessedContent(replaceVariablesInText(content));
  }, [content]);

  useEffect(()=> { 
    if (!doctorContactPage) return;
    if (stepIndex === activeStepIndex) {
      const doctorField = getFieldsFormSession(doctorContactField);
      setDoctorData(doctorField);
    }
  }, [doctorContactPage, doctorContactField, activeStepIndex, stepIndex]);

  useEffect(()=> { 
    if (stepIndex === activeStepIndex) {
      setProcessedContent(replaceVariablesInText(content));
    }
  }, [activeStepIndex, stepIndex]);

  return (
    <div className={b()} >
      {content && <div className={`fc-page-content ${b("content")}`} dangerouslySetInnerHTML={{ __html: s(processedContent) }} />}
      {showCopyMail && (
        <button type="button" className={`fc-copy-button ${b("copybutton")}`} onClick={handleCopyMail}
          style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "12px 18px", border: "1.5px solid #E5E5E5", borderRadius: "12px", background: "#fff", color: "#05132f", fontSize: "14px", fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
          {copied ? "Kopiert ✓" : "Kopieren"}
        </button>
      )}
      {iframe?.map((el: any, i: number) => (
        <div key={i} className={b("iframe")}>
          <iframe src={el.iframeUrl} width="100%" height={el.iframeHeight} />
        </div>
      ))}

      {doctorData && (
        <div className={b("content")}>
          <p>
            <b>{doctorData.full_name}</b><br />
            {doctorData.address}<br />
            {doctorData.phone_number && (
              <>Telefon-Nr.: <a href={`tel:${doctorData.phone_number}`}>{doctorData.phone_number}</a><br /></>
            )}
            {doctorData.email && (
              <>E-Mail.: <a href={`mailto:${doctorData.email}`}>{doctorData.email}</a></>
            )}
          </p>
          <p className={b("doctornote")}>
            Hinweis: Sie können Ihrem Arzt gerne sagen, dass Sie gerne eine Kranus Lutera Verodnung hätten - es kann sein, dass Sie dadurch schneller einen Termin kriegen könnten.
          </p>
          {doctorData.phone && (
            <a className={b("callbutton")} href={`tel:${doctorData.phone}`}>Praxis jetz anrufen</a>
          )}
        </div>
      )}

      {!!vimeoId && <VideoElement vimeoId={vimeoId} />}

      <div className={b()}>
        <div className={b()}>
          {!isSuccessPage && <NextButton handleOnClick={handleClick} stepLabel={label} submitBtnText={customNextButton || submitButtonText} />}
        </div>
        { skipButton && 
            <SkipButton skipBtnText={skipButton} stepLabel={label} nextStep={nextStep}/>
          }
      </div>
    </div>
  )
}

export default StepPage;

